import React, { useState, useRef } from "react";
import styled from 'styled-components';
import { useLocation, useNavigate } from "react-router-dom";
import { LogoutButton } from '@prosolve/common-components-ui'
import ProsolveLogo from '../images/prosolve-logo-slim.png';
import StarLogo from '../images/star-logo.png';
import useFetch from '../hooks/useFetch';
import { FaBars } from 'react-icons/fa';
import { getClientSubdomain, checkHasEditEventTemplatePermissions } from '../utils';

const DrawerWrapper = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0px;
  left: ${props => props.$open ? '0px' : 'calc(-100vw)' };
  transition: left 225ms cubic-bezier(0, 0, 0.2, 1), opacity 225ms cubic-bezier(0, 0, 0.2, 1);
  /* background: #b8b8b877; */
  background: transparent;
  z-index: 100001
`

const Drawer = styled.div`
  display: block;
  flex-wrap: wrap;
  width: 240px;
  height: 100%;
  background: #ffffff;
  border-right: 1px solid #c2c9d1;
`

export default () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const [isDrawerOpen, setIsDrawerOpen] = useState(false)

  const fetch = useFetch();

  const clientSubdomain = getClientSubdomain()

  const isStarSubdomain = (clientSubdomain === 'star')
  
  const itemStyle = {
    color: '#565656',
    padding: '7px 15px',
    cursor: 'pointer',
    borderRadius: '10px',
    fontSize: '14px'
  }

  const selectedStyle = {
    background: '#F3FBFF',
    color: '#0280c6'
  }

  const onItemClicked = (name) => {
    setIsDrawerOpen(false)
    if (pathname !== `/${name}`) {
      navigate(`${name}`);
    }
  }

  const Tab = ({ name, path }) => {
    let extraStyle;
    if (pathname === '/') {
      extraStyle = (path === 'home' ? selectedStyle : {});
    } else {
      extraStyle = (pathname?.includes(path) ? selectedStyle : {});
    }
    return (
      <div
        style={{
          ...itemStyle,
          ...extraStyle
        }}
        onClick={() => onItemClicked(path)}
      >
        {name}
      </div>
    )
  }

  const hasEditEventTemplatePermissions = checkHasEditEventTemplatePermissions()

  const drawerRef = useRef()

  const onDrawerWrapperClicked = (event) => {
    if (!(drawerRef.current && drawerRef.current.contains(event.target))) {
      setIsDrawerOpen(false)
    }
  }

  /*{
    !isStarSubdomain &&
    <Tab name='Trainer Dashboard' path='trainer' />
  }*/

  return (
    <>
    <DrawerWrapper $open={isDrawerOpen} onClick={onDrawerWrapperClicked}>
      <Drawer ref={drawerRef}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          padding: '15px 10px',
          gap: '10px'
        }}>
          <Tab name='Home' path='home' />
          { hasEditEventTemplatePermissions &&
            <Tab name='Design Center' path='design' />
          }
        </div>
      </Drawer>
    </DrawerWrapper>
    <div style={{
      position: 'sticky',
      top: '0',
      zIndex: '999',
      display: 'flex',
      height: '39px',
      padding: '0px 20px',
      alignItems: 'center',
      background: '#ffffff',
      color: '#080808',
      borderBottom: '1px solid #C2C9D1',
    }}>
      <div 
        style={{
          position: 'relative',
          cursor: 'pointer',
          width: '16px',
          height: '16px',
          padding: '6px',
          border: '1px solid #c2c9d1',
          borderRadius: '5px',
          marginLeft: '-5px',
          marginRight: '10px'
        }}
        onClick={() => setIsDrawerOpen(true)}
      >
        <FaBars style={{ color: '#7e7e7e', fontSize: '16px' }} />
      </div>
      {
        isStarSubdomain ?
        <img 
          src={StarLogo} 
          style={{ height: '32px', marginRight: '30px', marginLeft: '12px', cursor: 'pointer' }} 
          alt="prosolveLogo" 
          onClick={() => navigate('home')}
        />
        :
        <img 
          src={ProsolveLogo} 
          style={{ height: '45px', marginRight: '20px', cursor: 'pointer' }} 
          alt="prosolveLogo" 
          onClick={() => navigate('home')}
        />
      }
      <div style={{ flex: 1 }}>&nbsp;</div>
      <LogoutButton fetch={fetch} />
    </div>
    </>
  )
}